import ko from './ko'
import en from './en'

const messages = {
    ko: ko,
    en :en
}
export default messages